import React, { useState, useEffect,useContext } from 'react';
import { Link, useNavigate,useParams  } from 'react-router-dom';

import JisCheckbox from '../../components/controls/jisCheckbox';
import JisButton from '../../components/controls/jisButton';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import * as Constants from '../../constants';
import '../../styles/document_upload.css';
import '../../styles/template.css'
import DynamicIcon from '../../components/dynamicicon';
import JisAlert from '../../components/jisalert';
import JisDialog from '../../components/dialog';
import PdfViewer from '../../components/controls/pdfviewer';

function AffidavitUpload() {

    const [cinfo, setCase]=useState({});
    const [flow, setFlow] = useState({pos:1, code:"doc_type"});
    const [flowerror, setFlowError]=useState('');
    const [option, setOption]=useState('');
 const [uploadtype, setUploadType]=useState(option);
 const [activeIndex, setActiveIndex] = useState(-1);
 const [uploadcode, setUploadCode]= useState(0);


      const navigate = useNavigate()
    const {docid} = useParams();
    const { activePage, token, profile,setIsExpired } = useContext(ShareContext)
    const [eswear, setEswear] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [loading,setLoading]= useState(false);
    //for upload document**************************************
   


    const [document, setDocuments] =useState({uplines:[], casedetail:{}});
    const url=`${Constants.apiUrl}/filing/uncompletedUpload-docid/${docid}`;
   
    
    
    const [selectedItems, setSelectedItems] = useState({});

    const [openTemp, setOpenTemp ] =useState(false);

    const [templates, setTemplates]=useState([]);
    const [activeRow, setActiveRow] = useState({});
    const [isPreview, setIsPreview] =useState(false);
    const [previewPath, setPreviewPath] = useState(false);
    const [prevImgs, setPrevImgs] =useState([]);
    const [alert, setAlert]=useState ({open:false,title:'', subtitle:''})
    const [caseDetails, setCaseDetails] =useState({});
    const [openType, setOpenType] = useState(false);
    const [isAttendedTo,setisAttendedTo ]=useState(false);



    useEffect(() => {
        LoadDocs();
  
       
      }, [])

   
      const onOk=()=>{
        navigate(`/affidavit-prepare/${docid}/user`);
      }
     const onPreview=(obj)=>{
        setIsPreview(true);
        setPreviewPath(obj.path);
     }

    const handleUploadChange =async (e, rowIndex) => {
        var uline= {...document[rowIndex]};
        var updatedselectedItems={...selectedItems};
       // var updateditems=new Set(items);
       var _uplines=document.uplines;
       setActiveIndex(rowIndex);
       
       

        const files = e.target.files;
        console.log(files[0]);
        var b64=await Constants.toBase64(files[0]);
        var path =URL.createObjectURL(files[0]);
        var fname=Constants.ReduceFilename(files[0]?.name);

       var a={... _uplines[rowIndex], path, base64:b64.split(',')[1],filename: fname, base64Ext:b64.split(',')[0]};

       _uplines[rowIndex]=a;
   
         setDocuments({...document,uplines:_uplines});

        console.log(_uplines);
      
    };


    const LoadDocs=()=>{
        setLoading(true);
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
          })
            .then((resp) => resp.json())
            .then((data) => {
                setLoading(false);
                console.log(data);
                if(data.code==0){
                    setDocuments({...data.doc,uplines:data.lines});
                   if(data.lines.length==1 && data.lines[0].isTemplate){
                    onOk(); //goto prepare straigt
                   }
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
                
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            })
    }

    // console.log(uploadedFiles);


    const onUploadFiles2= async()=>{
        const uploadurl=`${Constants.apiUrl}/filing/uploadAffidavit/${docid}`
   
const _uplines = document.uplines.filter(k=>(k.uplineType!=null && k.uploadDate==null)).map(item => ({
                id: item.id,
                uplineType: item.uplineType,
                base64: item.base64,
                base64Ext: item.base64Ext,
                templateId:item.templateid,
                templatetitle: item.templatetitle,
                filename:item.filename
                }));

    const unset= _uplines
      .filter(k=> (k.uplineType!='template' && k.base64==null));
  console.log('the file not set at all')              
  console.log(unset) ;
  if(unset.length>0){
    // a message should pop up
    setFlowError("Please select the associated files");
      return;      
  }

  if(_uplines.length==0){
      setFlowError("Please set the file upload type and upload the corresponding documents");
      return; 
  }

  setFlowError('');
  
//loop throu, any type of template must have template id
//and others must have base6
         

            // Sending the FormData using fetch
            setLoading(true);
            fetch(uploadurl, {
            method: 'POST',
            body: JSON.stringify(_uplines),
            headers: {
                'Content-Type': 'application/json, text/plain',
                Authorization: `Bearer ${token}`,
                },
            })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if(data.code==0){
                    //saved already
                    setOpenDialog(true);
                   
                } else if(data.code==-10){
                      setIsExpired(true);
                  }
            })
            .catch(error => {
                console.error('Error:', error);
                setLoading(false);
        });
    }

  

  





  return (
    <div>
      <h1>Affidavit upload</h1>
      <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.referenceNumber}</h3>
        </div>
       <div  className='multiform'>
        
        
            <div className='view'>
                
                  <div  className='table'>
                    <div class="section-cases">
                    <span>Documents upload from Gazette Selection</span>
                    </div>
                <div>
                    <table class="case-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th> Title</th>
                                
                                <th>Status</th>
                                <th>Document Type</th>
                                <th></th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {
                                document?.uplines.map((item, index) => { return (
                                <tr key={index}>
                                    <td>LSJ/HC/AFF/{item.id}</td>
                                    <td>{item.documentTitle}</td>
                                    <td className={item.uploadDate!=null ? "status uploaded" :"status"}>
                                      {item.uploadDate!=null ? `${item.isTemplate?'Template Selected':'Uploaded'}`:'Pending Upload'}
                                    </td>

                                  {item.uploadDate!=null && <td></td> }  
                      {item.uploadDate==null && <td className="file">
 
  {item.uplineType == null ? null : (
(
      // uplineType is 'attest' or 'not-attest'
      (item.uplineType === 'attest' || item.uplineType === 'not-attest') &&
      
        <div className="btn-upload">
          <input
            type="file"
            accept="application/pdf"
            id={`file-upload-${index}-${0}`}
            onChange={(e) => handleUploadChange(e, index)}
          />
          <label
            htmlFor={`file-upload-${index}-${0}`}
            title={item?.filename}
          >
            {item.path == null
              ? 'Choose File'
              : Constants.ReduceString(
                  item?.filename,
                  30
                )}
          </label>
          {item.path!=null && <JisButton onClick={()=> onPreview(item)}>Preview</JisButton>}
        </div>
      
    )
  )}
</td>}     
{item.uploadDate!=null && <td></td>}
                                </tr>
                                )})
                            }
                        </tbody>
                    </table>
                </div>
              {flowerror!='' && <div className='error'>{flowerror}</div>}  
<div className='flowbuttongroup'>
                        <JisButton onClick={onUploadFiles2}>Upload File/Template</JisButton>
                    </div>

              {openDialog && <JisDialog title="Upload">
<div className="wrapper">
                        <h3>UPLOAD IS SUCCESSFUL</h3>
                        <div className="main">
                            <p>Upload is successful! kindly Click Ok and 
                                check back within your account to see if the Commissioner for Oath (CFO) has scheduled your Affidavit and associated Exhibits for attestation/commissioning. 
                               
                               </p>
                            <div className="btns">
                               <JisButton onClick={() =>  navigate('/affidavits')} icon="check_circle">Ok</JisButton>
                              <JisButton onClick={onOk} icon="check_circle">Prepare Document</JisButton>
                            </div>  
                        </div>
                    </div>
                    
              </JisDialog>
              
              }  
          
            </div>

           {isPreview && <div className={  "preview open" } style={{overflow:'scroll'}}>
                <div className="heading">
                  <div>
                    <JisButton icon="close"  onClick={() => setIsPreview(false)}> Close Preview</JisButton>
                     </div>
                  
                </div>
               <PdfViewer   pdfUrl={previewPath}/>
                
                
                <div className="date-btns">
                    
                  
                </div>
            </div>}

            </div>

        </div> 
        <BackLoader open={loading} />
    </div>
  );
}

export default AffidavitUpload;